import { ServicePage } from '../ServicePage';

export default function Wedding() {
  return (
    <ServicePage
      categoryKey="wedding"
      heroImage="https://images.unsplash.com/photo-1765308767818-1e7fd17c8067?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1800"
      overline="Hizmetlerimiz"
      headline="Düğün"
      headlineAccent="Zarif. İnce. Unutulmaz."
      intro="Her aşk hikayesi benzersizdir. İMER, sizin düğününüzü de öyle yaklaşır. Estetik hassasiyeti, planlama disiplini ve duygu mimarisini bir araya getirerek hayalinizdeki deneyimi hayata geçiriyoruz."
      inclusions={[
        { title: 'Tören Tasarımı & Dekorasyon', desc: 'Baştan sona özel tasarım, çiçek düzenlemeleri ve dekor' },
        { title: 'Mekân Seçimi & Yönetimi', desc: 'Size uygun en prestijli ve anlamlı mekânları keşfediyoruz' },
        { title: 'Aydınlatma & Atmosfer', desc: 'Duygusal atmosferi tamamlayan özel ışık düzeni' },
        { title: 'Catering & Menü Planlaması', desc: 'Premium yemek ve ikram koordinasyonu' },
        { title: 'Müzik & Eğlence', desc: 'Canlı müzik veya DJ koordinasyonu' },
        { title: 'Fotoğraf & Video Koordinasyonu', desc: 'Profesyonel ekiplerle anılarınızı ölümszleştirin' },
        { title: 'Davetiye & Konaklama', desc: 'Misafir yolculuğu ve konaklama planlaması' },
        { title: 'Etkinlik Günü Koordinasyon', desc: 'Tüm gün boyunca deneyimli koordinasyon ekibi' },
      ]}
      processSteps={[
        { num: '01', title: 'Tanışma & Hayal', desc: 'Sizinle tanışır, hayalinizdeki düğünü, beklentilerinizi ve hikayenizi dinliyoruz.' },
        { num: '02', title: 'Konsept & Estetik', desc: 'Renk paleti, üslup, mekân ve tasarım konseptini birlikte belirliyoruz.' },
        { num: '03', title: 'Planlama & Organizasyon', desc: 'Tüm tedarikçileri, mekânı ve lojistiği profesyonelce yönetiyoruz.' },
        { num: '04', title: 'Düğün Provaları', desc: 'Tören akışı, mekân kurulumu ve son detayları kontrol ediyoruz.' },
        { num: '05', title: 'Mutlu Gününüz', desc: 'Siz sadece anın tadını çıkarın. Biz her detayınızla ilgileniyoruz.' },
      ]}
      signatureDetails={{
        title: 'Her Çift, Kendine Özel Bir Deneyim Hak Eder',
        body: 'İMER düğün organizasyonlarında, çiftin kimliğini, estetik beğenisini ve duygusal dünyasını yansıtan tamamen kişisel bir deneyim tasarlarız. Çünkü her aşk hikayesi, kendine has bir şekilde anlatılmayı hak eder.',
        list: [
          'Nikan, nişan ve düğün törenleri',
          'Full konsept tasarımı',
          'Sâde ve butik düğünler',
          'Büyük prodlerişonlu düğün geceleri',
          'Yurt dışı düğün koordinasyonu',
        ],
        image: 'https://images.unsplash.com/photo-1769981493694-0560b2ac128b?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900',
      }}
      faqItems={[
        { q: 'Kaç ay önceden başlamalıyız?', a: 'Düğün organizasyonu için en az 6-12 ay önceden başlamalıyız. Yoğun sezonda mekân ve tedarikçi rezervasyonları için erkenden başlamak önerilir.' },
        { q: 'Yurt dışında düğün planlıyor olsak yardımcı olabilir misiniz?', a: 'Türkiye içinde her şehirde organize ediyoruz. Yurt dışı talepleri için özel koordinasyon paketlerimiz mevcuttur.' },
        { q: 'Hem tören hem gece organizasyonunu yönetiyor musunuz?', a: 'Evet, törenden sonraki gece etkinliğine kadar tüm günü kapsayan tam hizmet sunuyoruz.' },
      ]}
    />
  );
}
